module.exports = [{
      plugin: require('/Users/apple/Desktop/Lab/labPluginTest/gatsby-theme-doc/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"]},
    }]
